<template>
  <toast ref="toastRef"/>

  <div id="navbar">
    <div id="title">
      <img src="/app.png" alt="none" style="height: 50px;width: 50px;margin-right: 10px">
      <span>方言地图</span>
    </div>
    <div id="right-column">
      <div id="menu">
        <div class="item" @click="router.push('/backend')">
          后台🪧
        </div>
        <a-popover trigger="click" placement="bottomLeft">
          <div class="item">
            工具🧰
          </div>
          <template #content>
            <div id="dialectSelector" @click="closeDropdown">
              <label>大方言区：</label>
              <DroppableInput
                  v-model="selectedLanguage"
                  :filtered-list="filteredLanguages"
                  :click-handler="languageOnClick"
                  :item-click="languageLiOnClick"
                  @input="onLInput"
                  :placeholder="'大方言区'"
                  :field="'lname'"
                  :input-style="'margin-bottom: 5%;margin-top: 10%'"
              />
              <br>
              <label>方言片：</label>
              <DroppableInput
                  v-model="selectedDialect"
                  :filtered-list="filteredDialects"
                  :click-handler="dialectOnClick"
                  :item-click="dialectLiOnClick"
                  @input="onDInput"
                  :placeholder="'方言片'"
                  :field="'dname'"
                  :input-style="'margin-bottom: 5%'"
              />
              <br>
              <label>方言小片：</label>
              <DroppableInput
                  v-model="selectedSubdialect"
                  :filtered-list="filteredSubdialects"
                  :click-handler="subDialectOnClick"
                  :item-click="subDialectLiOnClick"
                  @input="onSInput"
                  :placeholder="'方言小片'"
                  :field="'sname'"
                  :input-style="'margin-bottom: 5%'"
              />
              <br>
              <label>口音：</label>
              <DroppableInput
                  v-model="selectedAccent"
                  :filtered-list="filteredAccents"
                  :click-handler="accentOnClick"
                  :item-click="accentLiOnClick"
                  @input="onAInput"
                  :placeholder="'口音'"
                  :field="'aname'"
                  :input-style="'margin-bottom: 5%'"
              />
              <br>
              <div style="text-align: center">
                <button @click="findCountiesByDialects">筛选⏳</button>
                <button @click="clearPolygon(true)">清空❌</button>
              </div>
            </div>
          </template>
        </a-popover>

      </div>
      <a-dropdown trigger="click">
        <div id="user">
          <a-avatar :size="45" :style="'box-shadow: 3px 6px 6px rgba(0,0,0,.15);background-color: #eeeeee'" v-if="user" :src="`${domain}\\${user.avatar}`" />
          <span style="margin-left: 10px;font-size: 16px;font-weight: bold" v-if="user" id="uname">{{user.uname}}</span>
        </div>
        <template #overlay>
          <div id="user-profile">
            <a-avatar :size="45" :style="'box-shadow: 3px 6px 6px rgba(0,0,0,.15);background-color: #eeeeee'" v-if="user" :src="`${domain}\\${user.avatar}`"/>
            <div id="profile">
              UID:{{user.uid}}
              <div style="font-weight: bold;font-size: 16px">{{user.uname}}</div>
              <div style="font-size: 12px;margin-top: 5px">个人简介：{{user.signature}}</div>
            </div>
            <a-checkbox :checked="user.shared" @click="publicateData">公开数据</a-checkbox>
            <div id="user-buttons" style="margin-top: 10px">
              <a-button type="primary" :style="'margin-left:5px;margin-right:5px'" @click="()=>{router.push('/changeInfo')}">修改信息</a-button>
              <a-button type="primary" :style="'margin-left:5px;margin-right:5px'" @click="logout">退出登录</a-button>
            </div>
          </div>
        </template>
      </a-dropdown>

    </div>
  </div>

  <div id="toolbox">
    <transition name="menu">

    </transition>
    <div id="searchBox">
      <button id="mark" @click="markOnClick">定点📌</button>
      <button id="ruler" @click="rulerOnClick">测距📏</button>
      <button id="select" @click="selectOnClick">框选✍️</button>
      <input type="text" class="textbox" id="searchtext" ref="searchInput">
      <button id="searchbutton" @click="searchKeyword">搜索🔍</button>
    </div>
  </div>

  <!-- ==================== 标记信息窗 ==================== -->
  <div
      v-show="markerInfoVisible"
      class="info-overlay"
      :style="{left: markerInfoPos.x + 'px', top: markerInfoPos.y + 'px'}"
  >
    <a-card size="small" class="info-card">
      <template #title>
        <span class="info-card-title">{{ markerInfoData.address }}</span>
      </template>
      <template #extra>
        <a-button type="text" size="small" @click="closeInfoWindow" class="close-btn">✕</a-button>
      </template>

      <div class="info-label">地名信息</div>
      <div class="info-value">地址：{{ markerInfoData.address }}</div>
      <div class="info-value">{{ markerInfoData.position }}</div>

      <a-divider style="margin: 8px 0" />

      <div class="info-label">方言</div>
      <DroppableInput v-model="markerDialect.selectedLanguage" :filtered-list="markerDialect.filteredLanguages"
          :click-handler="markerDialect.languageOnClick" :item-click="markerDialect.languageLiOnClick"
          @input="markerDialect.onLInput" @close="markerDialect.closeDropdowns"
          placeholder="大方言区" field="lname"
          input-style="width:100%;margin-bottom:4px;height:20px"/>
      <DroppableInput v-model="markerDialect.selectedDialect" :filtered-list="markerDialect.filteredDialects"
          :click-handler="markerDialect.dialectOnClick" :item-click="markerDialect.dialectLiOnClick"
          @input="markerDialect.onDInput" @close="markerDialect.closeDropdowns"
          placeholder="方言片" field="dname"
          input-style="width:100%;margin-bottom:4px;height:20px"/>
      <DroppableInput v-model="markerDialect.selectedSubdialect" :filtered-list="markerDialect.filteredSubdialects"
          :click-handler="markerDialect.subDialectOnClick" :item-click="markerDialect.subDialectLiOnClick"
          @input="markerDialect.onSInput" @close="markerDialect.closeDropdowns"
          placeholder="方言小片" field="sname"
          input-style="width:100%;margin-bottom:4px;height:20px"/>
      <DroppableInput v-model="markerDialect.selectedAccent" :filtered-list="markerDialect.filteredAccents"
          :click-handler="markerDialect.accentOnClick" :item-click="markerDialect.accentLiOnClick"
          @input="markerDialect.onAInput" @close="markerDialect.closeDropdowns"
          placeholder="口音" field="aname"
          input-style="width:100%;height:20px"/>
      <a-button type="link" danger size="small" @click="clearInfoDialect" class="action-link">❌清空</a-button>

      <a-divider style="margin: 10px 0 6px" />

      <div class="info-label">备注</div>
      <a-textarea v-model:value="markerInfoData.remark" :rows="2" size="small" style="margin-top:4px" placeholder="添加备注..."/>

      <a-space style="margin-top:10px">
        <a-button type="primary" size="small" @click="handleSaveInfo">保存</a-button>
        <a-button danger size="small" @click="handleDeleteMarker">删除</a-button>
        <a-button size="small" @click="closeInfoWindow" :style="'background-color: #4a90e2'">关闭</a-button>
      </a-space>
    </a-card>
  </div>

  <!-- ==================== 区县信息窗 ==================== -->
  <div
      v-show="countyInfoVisible"
      class="info-overlay"
      :style="{left: countyInfoPos.x + 'px', top: countyInfoPos.y + 'px'}"
  >
    <a-card size="small" class="info-card">
      <template #title>
        <span class="info-card-title">{{ countyInfoData.address }}</span>
      </template>
      <template #extra>
        <a-button type="text" size="small" @click="closeCountyInfoWindow" class="close-btn">✕</a-button>
      </template>

      <div class="info-label">行政编码</div>
      <div class="info-value">{{ countyInfoData.adcode }}</div>

      <a-divider style="margin: 8px 0" />

      <div class="info-label">已有方言</div>
      <div v-if="countyInfoData.countyDialects.length" style="margin:4px 0">
        <a-tag
            v-for="cd in countyInfoData.countyDialects" :key="cd.cdid"
            closable @close="handleDeleteCountyDialect(cd)"
            color="blue" style="margin-bottom:4px"
        >
          {{ cd.lname }} · {{ cd.dname }} · {{ cd.sname }} · {{ cd.aname }}
        </a-tag>
      </div>
      <div v-else class="info-placeholder">暂无方言数据</div>

      <a-divider style="margin: 10px 0 6px" />

      <div class="info-label">新增方言</div>
      <DroppableInput v-model="countyDialect.selectedLanguage" :filtered-list="countyDialect.filteredLanguages"
          :click-handler="countyDialect.languageOnClick" :item-click="countyDialect.languageLiOnClick"
          @input="countyDialect.onLInput" @close="countyDialect.closeDropdowns"
          placeholder="大方言区" field="lname"
          input-style="width:100%;margin-bottom:4px;height:20px"/>
      <DroppableInput v-model="countyDialect.selectedDialect" :filtered-list="countyDialect.filteredDialects"
          :click-handler="countyDialect.dialectOnClick" :item-click="countyDialect.dialectLiOnClick"
          @input="countyDialect.onDInput" @close="countyDialect.closeDropdowns"
          placeholder="方言片" field="dname"
          input-style="width:100%;margin-bottom:4px;height:20px"/>
      <DroppableInput v-model="countyDialect.selectedSubdialect" :filtered-list="countyDialect.filteredSubdialects"
          :click-handler="countyDialect.subDialectOnClick" :item-click="countyDialect.subDialectLiOnClick"
          @input="countyDialect.onSInput" @close="countyDialect.closeDropdowns"
          placeholder="方言小片" field="sname"
          input-style="width:100%;margin-bottom:4px;height:20px"/>
      <DroppableInput v-model="countyDialect.selectedAccent" :filtered-list="countyDialect.filteredAccents"
          :click-handler="countyDialect.accentOnClick" :item-click="countyDialect.accentLiOnClick"
          @input="countyDialect.onAInput" @close="countyDialect.closeDropdowns"
          placeholder="口音" field="aname"
          input-style="width:100%;height:20px"/>

      <a-space style="margin-top:8px">
        <a-button type="primary" size="small" @click="handleAddCountyDialect" :disabled="!countyDialect.selectedLanguage.lname">添加</a-button>
        <a-button size="small" danger @click="countyDialect.clearSelection">❌清空</a-button>
      </a-space>

      <a-divider style="margin: 10px 0 8px" />

      <a-button size="small" block  @click="closeCountyInfoWindow" :style="'background-color: #4a90e2'">关闭</a-button>
    </a-card>
  </div>
</template>

<script setup>
import {ref, reactive, onMounted, computed, onUnmounted} from "vue"
import request from "@/utils/request.js";
import DroppableInput from "@/components/DroppableInput.vue";
import pako from 'pako';
import Toast from "@/components/Toast.vue";
import router from "@/router/index.js";
import {domain} from "@/utils/request.js";

const props = defineProps({
  map: Object,
})

let user = ref(null);
let searchInput = ref(null);
let district;
let polygons = []
let markers = []
let geocoder = null;
let isDrawingSegment = false;
let pointHeads = [];
let selectedArea, selectedAdcodes = [];
let segmentHeads = [];
let textHeads = [];
let languages = ref([]);
let dialects = ref([]);
let subdialects = ref([]);
let accents = ref([]);
let selectedLanguage = ref({lname: null, lid: 24});
let selectedDialect = ref({dname: null, did: 35});
let selectedSubdialect = ref({sname: null, sid: 34});
let selectedAccent = ref({aname: null, aid: 260});
let toastRef = ref(null)
let isShowingMenu = ref(false);
let isMarkOn = 0
let isSelectOn = 0
let isRulerOn = 0

// ==================== 标记信息窗状态 ====================
const markerInfoVisible = ref(false)
const markerInfoPos = ref({x: 0, y: 0})
const markerInfoLngLat = ref(null)
const currentFullMarker = ref(null) // 当前打开的标记引用
const markerInfoData = ref({
  address: '',
  position: '',
  remark: '',
})

// ==================== 区县信息窗状态 ====================
const countyInfoVisible = ref(false)
const countyInfoPos = ref({x: 0, y: 0})
const countyInfoLngLat = ref(null)
const countyInfoData = ref({
  address: '',
  adcode: '',
  countyDialects: [],
})

// ==================== 方言选择器 composable ====================
function useDialectSelector() {
  const languages = ref([])
  const dialects = ref([])
  const subdialects = ref([])
  const accents = ref([])

  const selectedLanguage = ref({lname: null, lid: 24})
  const selectedDialect = ref({dname: null, did: 35})
  const selectedSubdialect = ref({sname: null, sid: 34})
  const selectedAccent = ref({aname: null, aid: 260})

  const filteredLanguages = computed(() => {
    if (!selectedLanguage.value.lname) return languages.value
    return languages.value.filter(o => o.lname.includes(selectedLanguage.value.lname))
  })
  const filteredDialects = computed(() => {
    if (!selectedDialect.value.dname) return dialects.value
    return dialects.value.filter(o => o.dname.includes(selectedDialect.value.dname))
  })
  const filteredSubdialects = computed(() => {
    if (!selectedSubdialect.value.sname) return subdialects.value
    return subdialects.value.filter(o => o.sname.includes(selectedSubdialect.value.sname))
  })
  const filteredAccents = computed(() => {
    if (!selectedAccent.value.aname) return accents.value
    return accents.value.filter(o => o.aname.includes(selectedAccent.value.aname))
  })

  function clearSelection() {
    selectedLanguage.value = {lname: null, lid: 24}
    selectedDialect.value = {dname: null, did: 35}
    selectedSubdialect.value = {sname: null, sid: 34}
    selectedAccent.value = {aname: null, aid: 260}
  }

  function closeDropdowns() {
    languages.value = []
    dialects.value = []
    subdialects.value = []
    accents.value = []
  }

  function onLInput(e) {
    if (e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward')
      selectedLanguage.value = {lname: null, lid: 24}
  }
  function onDInput(e) {
    if (e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward')
      selectedDialect.value = {dname: null, did: 35}
  }
  function onSInput(e) {
    if (e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward')
      selectedSubdialect.value = {sname: null, sid: 34}
  }
  function onAInput(e) {
    if (e.inputType === 'deleteContentBackward' || e.inputType === 'deleteContentForward')
      selectedAccent.value = {aname: null, aid: 260}
  }

  async function languageOnClick() {
    const res = await request.get('/accent/languages')
    languages.value = res.data.filter(o => o.lname !== '暂无数据')
    dialects.value = []; subdialects.value = []; accents.value = []
  }

  function languageLiOnClick(language) {
    selectedLanguage.value = language
    languages.value = []
    selectedDialect.value = {dname: null, did: 35}
    selectedSubdialect.value = {sname: null, sid: 34}
    selectedAccent.value = {aname: null, aid: 260}
  }

  async function dialectOnClick() {
    let res
    if (selectedLanguage.value.lname)
      res = await request.get('/accent/dialects/' + selectedLanguage.value.lid)
    else
      res = await request.get('/accent/dialects/')
    dialects.value = res.data.filter(o => o.dname !== '暂无数据')
    languages.value = []; subdialects.value = []; accents.value = []
  }

  function dialectLiOnClick(dialect) {
    selectedDialect.value = dialect
    dialects.value = []
    selectedLanguage.value = dialect.language
    selectedSubdialect.value = {sname: null, sid: 34}
    selectedAccent.value = {aname: null, aid: 260}
  }

  async function subDialectOnClick() {
    let res
    if (selectedDialect.value.dname)
      res = await request.get('/accent/subdialects/' + selectedDialect.value.did)
    else
      res = await request.get('/accent/subdialects/')
    subdialects.value = res.data.filter(o => o.sname !== '暂无数据')
    languages.value = []; dialects.value = []; accents.value = []
  }

  function subDialectLiOnClick(subdialect) {
    selectedSubdialect.value = subdialect
    subdialects.value = []
    selectedDialect.value = subdialect.dialect
    selectedLanguage.value = subdialect.dialect.language
    selectedAccent.value = {aname: null, aid: 260}
  }

  async function accentOnClick() {
    let res
    if (selectedSubdialect.value.sname)
      res = await request.get('/accent/accents/' + selectedSubdialect.value.sid)
    else
      res = await request.get('/accent/accents/')
    accents.value = res.data.filter(o => o.aname !== '暂无数据')
    languages.value = []; dialects.value = []; subdialects.value = []
  }

  function accentLiOnClick(accent) {
    selectedAccent.value = accent
    accents.value = []
    selectedSubdialect.value = accent.subDialect
    selectedDialect.value = accent.subDialect.dialect
    selectedLanguage.value = accent.subDialect.dialect.language
  }

  return reactive({
    languages, dialects, subdialects, accents,
    selectedLanguage, selectedDialect, selectedSubdialect, selectedAccent,
    filteredLanguages, filteredDialects, filteredSubdialects, filteredAccents,
    languageOnClick, dialectOnClick, subDialectOnClick, accentOnClick,
    languageLiOnClick, dialectLiOnClick, subDialectLiOnClick, accentLiOnClick,
    onLInput, onDInput, onSInput, onAInput,
    clearSelection, closeDropdowns,
  })
}

const markerDialect = useDialectSelector()
const countyDialect = useDialectSelector()

// ==================== 辅助函数 ====================
function lnglatToPixel(lnglat) {
  const pixel = props.map.lngLatToContainer(lnglat);
  const container = props.map.getContainer();
  const rect = container.getBoundingClientRect();
  return {x: rect.left + pixel.x + 16, y: rect.top + pixel.y - 45};
}

function updateMarkerInfoPosition() {
  if (markerInfoLngLat.value) {
    markerInfoPos.value = lnglatToPixel(markerInfoLngLat.value);
  }
}

function updateCountyInfoPosition() {
  if (countyInfoLngLat.value) {
    countyInfoPos.value = lnglatToPixel(countyInfoLngLat.value);
  }
}

function updateAllInfoPositions() {
  if (markerInfoVisible.value) updateMarkerInfoPosition();
  if (countyInfoVisible.value) updateCountyInfoPosition();
}


async function refreshCountyDialects() {
  countyInfoData.value.countyDialects = (await request.get("/accent/accent/" + countyInfoData.value.adcode)).data;
}

// ==================== 标记信息窗操作 ====================
function closeInfoWindow() {
  markerInfoVisible.value = false;
  markerInfoLngLat.value = null;
  currentFullMarker.value = null;
  markerDialect.clearSelection();
}

function clearInfoDialect() {
  markerDialect.clearSelection();
}

async function handleDeleteMarker() {
  if (currentFullMarker.value) {
    await deleteMarker(currentFullMarker.value);
  }
}

async function handleSaveInfo() {
  if (!currentFullMarker.value) return;
  const fullMarker = currentFullMarker.value;
  const ml = markerDialect.selectedLanguage
  const md = markerDialect.selectedDialect
  const ms = markerDialect.selectedSubdialect
  const ma = markerDialect.selectedAccent
  // console.log("markerDialect")
  // console.log(markerDialect)

  await request.put("/marker/marker", {
    mid: fullMarker.mid,
    remark: markerInfoData.value.remark,
    lname: ml.lname,
    dname: md.dname,
    sname: ms.sname,
    aname: ma.aname,
  });
  let index = markers.indexOf(fullMarker);
  if (index !== -1) {
    markers[index].remark = markerInfoData.value.remark;
    markers[index].lname = ml.lname;
    markers[index].dname = md.dname;
    markers[index].sname = ms.sname;
    markers[index].aname = ma.aname;
  }
  closeInfoWindow();
}

// ==================== 区县信息窗操作 ====================
function closeCountyInfoWindow() {
  countyInfoVisible.value = false;
  countyInfoLngLat.value = null;
  countyDialect.clearSelection();
}

async function handleDeleteCountyDialect(countyDialect) {
  await request.delete(`/accent/county-dialect/${countyDialect.cdid}`);
  await refreshCountyDialects();
}

async function handleAddCountyDialect() {
  const cl = countyDialect.selectedLanguage
  if (cl.lname != null) {
    await request.post("/accent/county/" + countyInfoData.value.adcode + "/accent", {
      lid: cl.lid,
      did: countyDialect.selectedDialect.did,
      sid: countyDialect.selectedSubdialect.sid,
      aid: countyDialect.selectedAccent.aid,
    });
    await refreshCountyDialects();
  }
}

// ==================== 下拉框计算属性 ====================
const filteredLanguages = computed(() => {
  if (!selectedLanguage.value.lname) return languages.value
  return languages.value.filter(o =>
      o.lname.includes(selectedLanguage.value.lname)
  )
})
const filteredDialects = computed(() => {
  if (!selectedDialect.value.dname) return dialects.value
  return dialects.value.filter(o =>
      o.dname.includes(selectedDialect.value.dname)
  )
})
const filteredSubdialects = computed(() => {
  if (!selectedSubdialect.value.sname) return subdialects.value
  return subdialects.value.filter(o =>
      o.sname.includes(selectedSubdialect.value.sname)
  )
})
const filteredAccents = computed(() => {
  if (!selectedAccent.value.aname) return accents.value
  return accents.value.filter(o =>
      o.aname.includes(selectedAccent.value.aname)
  )
})

// ==================== 用户操作 ====================
const publicateData = async () => {
  user.value.shared = !user.value.shared;
  const formData = new FormData()
  formData.append("shared", user.value.shared)
  await request.put("/auth/change", formData);
}

const logout = async () => {
  localStorage.removeItem("token")
  await router.replace("/login")
}

// ==================== 选择框操作 ====================
function clearSelectionBox() {
  selectedLanguage.value = ({lname: null, lid: 24})
  selectedDialect.value = ({dname: null, did: 35})
  selectedSubdialect.value = ({sname: null, sid: 34})
  selectedAccent.value = ({aname: null, aid: 260})
}

// ==================== 筛选与多边形 ====================
function clearPolygon(needCleanSelections) {
  if (needCleanSelections) {
    clearSelectionBox()
  }
  closeCountyInfoWindow()
  selectedArea.setAdcode([])
  selectedAdcodes.length = 0;
  for (let marker of markers) {
    marker.marker.setIcon(new AMap.Icon({
      size: new AMap.Size(25, 34),
      image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
      imageSize: new AMap.Size(25, 34)
    }));
  }
  polygons.length = 0;
}

// ==================== 下拉输入事件 ====================
function onLInput(e) {
  if (e.inputType === 'deleteContentBackward' ||
      e.inputType === 'deleteContentForward') {
    selectedLanguage.value = {lname: null, lid: 24}
  }
}

function onDInput(e) {
  if (e.inputType === 'deleteContentBackward' ||
      e.inputType === 'deleteContentForward') {
    selectedDialect.value = {dname: null, did: 35};
  }
}

function onSInput(e) {
  if (e.inputType === 'deleteContentBackward' ||
      e.inputType === 'deleteContentForward') {
    selectedSubdialect.value = {sname: null, sid: 34};
  }
}

function onAInput(e) {
  if (e.inputType === 'deleteContentBackward' ||
      e.inputType === 'deleteContentForward') {
    selectedAccent.value = {aname: null, aid: 260};
  }
}

// ==================== 方言选择事件 ====================
async function accentOnClick() {
  let res;
  if (selectedSubdialect.value.sname)
    res = await request.get('/accent/accents/' + selectedSubdialect.value.sid)
  else
    res = await request.get('/accent/accents/')
  accents.value = res.data;
  accents.value = accents.value.filter(o =>
      o.aname !== '暂无数据'
  )
  languages.value = [];
  dialects.value = [];
  subdialects.value = [];
}

function accentLiOnClick(accent) {
  selectedAccent.value = accent;
  accents.value = [];
  selectedSubdialect.value = accent.subDialect;
  selectedDialect.value = accent.subDialect.dialect;
  selectedLanguage.value = accent.subDialect.dialect.language;

}

async function subDialectOnClick() {
  let res;
  if (selectedDialect.value.dname)
    res = await request.get('/accent/subdialects/' + selectedDialect.value.did)
  else
    res = await request.get('/accent/subdialects/')
  subdialects.value = res.data;
  subdialects.value = subdialects.value.filter(o =>
      o.sname !== '暂无数据'
  )
  languages.value = [];
  dialects.value = [];
  accents.value = [];
}

function subDialectLiOnClick(subdialect) {
  selectedSubdialect.value = subdialect;
  subdialects.value = [];
  selectedDialect.value = subdialect.dialect;
  selectedLanguage.value = subdialect.dialect.language;
  selectedAccent.value = {aname: null, aid: 260};

}

function dialectLiOnClick(dialect) {
  selectedDialect.value = dialect;
  dialects.value = [];
  selectedLanguage.value = dialect.language;
  selectedSubdialect.value = {sname: null, sid: 34};
  selectedAccent.value = {aname: null, aid: 260}

}

async function dialectOnClick() {
  let res;
  if (selectedLanguage.value.lname)
    res = await request.get('/accent/dialects/' + selectedLanguage.value.lid)
  else
    res = await request.get('/accent/dialects/')
  dialects.value = res.data;
  dialects.value = dialects.value.filter(o =>
      o.dname !== '暂无数据'
  )
  languages.value = [];
  subdialects.value = [];
  accents.value = [];
}

function languageLiOnClick(language) {
  selectedLanguage.value = language;
  languages.value = [];
  selectedDialect.value = {dname: null, did: 35};
  selectedSubdialect.value = {sname: null, sid: 34};
  selectedAccent.value = {aname: null, aid: 260};

}

async function languageOnClick() {
  const res = await request.get('/accent/languages')
  languages.value = res.data;
  languages.value = languages.value.filter(o =>
      o.lname !== '暂无数据'
  )
  dialects.value = [];
  subdialects.value = [];
  accents.value = [];
}

// ==================== 行政区筛选 ====================
async function findCountiesByDialects() {
  selectedArea.setAdcode([])
  polygons.length = 0
  for (let marker of markers) {
    marker.marker.setIcon(new AMap.Icon({
      size: new AMap.Size(25, 34),
      image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
      imageSize: new AMap.Size(25, 34)
    }));
  }

  const counties = (await request.get("/county/counties", {
    params: {
      language: selectedLanguage.value.lname,
      dialect: selectedDialect.value.dname,
      subDialect: selectedSubdialect.value.sname,
      accent: selectedAccent.value.aname,
    }
  })).data
  selectedAdcodes.length = 0;
  for (let county of counties) {
    let paths = JSON.parse(county.polygon).features[0].geometry.coordinates[0];
    selectedAdcodes.push(county.adcode);
    getPolygonFromDatabase(paths, 0)
  }
  selectedArea.setAdcode(selectedAdcodes)
  props.map.setFitView(polygons);

  let findMarkers = (await request.get("/marker/markers/accent", {
    params: {
      language: selectedLanguage.value.lname,
      dialect: selectedDialect.value.dname,
      subdialect: selectedSubdialect.value.sname,
      accent: selectedAccent.value.aname,
    }
  })).data
  for (let findMarker of findMarkers) {
    let fullMarker = null;
    for (let marker of markers) {
      if (marker.mid === findMarker.mid) {
        fullMarker = marker;
        break
      }
    }
    if (fullMarker)
      fullMarker.marker.setIcon(new AMap.Icon({
        size: new AMap.Size(25, 34),
        image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
        imageSize: new AMap.Size(25, 34)
      }));
  }
}

// ==================== 多边形工具 ====================
function getPolygon(adcode, paths) {
  return new Promise(resolve => {
    district.search(adcode, (status, result) => {
      if (status === "complete") {
        const bounds = result.districtList[0].boundaries;
        if (bounds) {
          bounds.forEach(path => {
            paths.push(path)
          });
        }
      }
      resolve();
    });
  });
}

function getPolygonFromDatabase(paths, needClear) {
  if (needClear) clearPolygon(false);
  if (paths.length) {
    paths.forEach(path => {
      const polygon = new AMap.Polygon({
        path,
        strokeWeight: 1,
        fillOpacity: 0.4,
        fillColor: "#80d8ff",
        strokeColor: "#0091ea"
      });
      polygons.push(polygon);
    })
  }
}

// ==================== 工具栏模式切换 ====================
function selectOff() {
  isSelectOn = 0;
  document.getElementById("select").textContent = "框选✍️";
}

function selectOn() {
  isSelectOn = 1;
  document.getElementById("select").textContent = "鼠标🖱️";
}

function rulerOff() {
  isRulerOn = 0;
  document.getElementById("ruler").textContent = "测距📏";
}

function rulerOn() {
  toastRef.value.showMessage('🔔点击红色的端点删除一整条折线');
  document.getElementById("ruler").textContent = "鼠标🖱️";
  isRulerOn = 1;
}

function markOff() {
  isMarkOn = 0;
}

function markOn() {
  isMarkOn = 1;
}

// ==================== 搜索 ====================
function searchKeyword() {
  let keyword = searchInput.value.value;
  district.search(keyword, (status, result) => {
    if (
        status === 'complete' &&
        result.districtList &&
        result.districtList.length > 0 &&
        result.districtList[0].level !== 'street'
    ) {
      const bounds = result.districtList[0].boundaries
      if (!bounds) return
      polygons.length = 0;
      bounds.forEach(boundary => {
        polygons.push(
            new AMap.Polygon({
              path: boundary,
              strokeColor: "#FF33FF",
              strokeWeight: 2,
              fillOpacity: 0.2,
              fillColor: "#1791fc",
            })
        )
      })
      selectedArea.setAdcode(result.districtList[0].adcode);
      props.map.setFitView(polygons);
    } else {
      searchPlace(keyword)
    }
  })
}

function searchPlace(address) {
  AMap.plugin("AMap.Geocoder", function () {
    if (address === '') return
    geocoder.getLocation(address, async (_, result) => {
      if (!result.geocodes.length) return
      const lnglat = result.geocodes[0].location
      await addMarker(null, lnglat, '', null, true, true)
    })
  })
}

// ==================== 关闭操作 ====================
function closeDropdown() {
  languages.value = [];
  dialects.value = [];
  subdialects.value = [];
  accents.value = [];
}

async function deleteMarker(marker) {
  closeInfoWindow();
  props.map.remove(marker.marker);
  let index = markers.indexOf(marker)
  if (index !== -1) {
    markers.splice(index, 1);
    await request.delete("/marker/marker/" + marker.mid)
  }
}

// ==================== 工具栏按钮切换 ====================
function rulerOnClick() {
  if (isRulerOn) {
    rulerOff();
  } else {
    rulerOn();
    markOff();
    selectOff();
  }
}

function markOnClick() {
  markOn();
  selectOff();
  rulerOff();
}

function selectOnClick() {
  if (isSelectOn) {
    selectOff();
    clearPolygon(false);
  } else {
    markOff();
    rulerOff();
    selectOn();
  }
}

function computeDis(p1, p2, text) {
  let textPos = p1.divideBy(2).add(p2.divideBy(2));
  let distance = Math.round(p1.distance(p2));
  text.setText(distance / 1000 + 'km')
  text.setPosition(textPos)
}

// ==================== 标记操作 ====================
async function addMarker(mid, lnglat, remark = '', accent = null, needAddToDatabase = true, needFit = false) {
  let marker = new AMap.Marker({
    icon: new AMap.Icon({
      size: new AMap.Size(25, 34),
      image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
      imageSize: new AMap.Size(25, 34)
    })
  });
  let adcode, address;
  await geocoder.getAddress(lnglat, async (status, result) => {
    if (status === 'complete' && result.regeocode) {
      adcode = result.regeocode.addressComponent.adcode;
      address = result.regeocode.formattedAddress;
      if (!accent) {
        accent = (await request.get('/accent/accent/' + adcode)).data;
        if (accent.length === 0) {
          accent = {
            lid: 24,
            did: 35,
            sid: 34,
            aid: 260,
            lname: '暂无数据',
            dname: '暂无数据',
            sname: '暂无数据',
            aname: '暂无数据'
          }
        } else
          accent = accent[0]
      }
      let fullMarker = {
        mid: mid,
        marker: marker,
        remark: remark,
        lid: accent.lid,
        did: accent.did,
        sid: accent.sid,
        aid: accent.aid,
        lname: accent.lname,
        dname: accent.dname,
        sname: accent.sname,
        aname: accent.aname,
      };
      props.map.add(marker);
      marker.setPosition(lnglat);
      markers.push(fullMarker);
      if (needAddToDatabase) {
        let newMarker = markers[markers.length - 1]
        mid = (await request.post("/marker/marker", {
          lng: lnglat.lng,
          lat: lnglat.lat,
          remark: newMarker.remark,
          lid: newMarker.lid,
          did: newMarker.did,
          sid: newMarker.sid,
          aid: newMarker.aid,
        })).data;
        markers[markers.length - 1].mid = mid;
        fullMarker.mid = mid;
      }
      if (needFit)
        props.map.setFitView(marker)

      // ===== 标记点击：打开Vue信息窗 =====
      markers[markers.length - 1].marker.on('click', async (e) => {
        markerDialect.clearSelection();
        const myMarker=(await request.get(`/marker/marker/${fullMarker.mid}`)).data
        console.log(myMarker)
        markerDialect.selectedLanguage = {lname: myMarker.lname, lid: myMarker.lid}
        markerDialect.selectedDialect = {dname: myMarker.dname, did: myMarker.did}
        markerDialect.selectedSubdialect = {sname: myMarker.sname, sid: myMarker.sid}
        markerDialect.selectedAccent = {aname: myMarker.aname, aid: myMarker.aid}
        currentFullMarker.value = fullMarker;
        markerInfoData.value = {
          address: address,
          position: "坐标：" + lnglat,
          remark: myMarker.remark,
        };
        markerInfoLngLat.value = lnglat;
        markerInfoVisible.value = true;
        updateMarkerInfoPosition();
      });
    } else {
      await addMarker(mid, lnglat, remark, accent, needAddToDatabase, needFit);
    }
  })
}

// ==================== 生命周期 ====================
onMounted(async () => {
  user.value = (await request.get("/auth/user")).data;
  selectedArea = new AMap.DistrictLayer.Province({
    zIndex: 10,
    zooms: [2, 15],
    adcode: [],
    depth: 2,
    opacity: 0.4,
  });

  selectedArea.setStyles({
    "stroke-width": 2,
    fill: function (data) {
      return "rgb(180,250,200)";
    },
    "county-stroke": "rgb(100,180,160)",
  });

  // 地图移动时更新信息窗位置
  props.map.on('moveend', updateAllInfoPositions);
  props.map.on('zoomend', updateAllInfoPositions);

  const deleteTail = () => {
    isDrawingSegment = false;
    if (!segmentHeads.length || !segmentHeads[segmentHeads.length - 1]) return
    let lastSegment = segmentHeads[segmentHeads.length - 1].next;
    if (!segmentHeads[segmentHeads.length - 1].next) {
      lastSegment = segmentHeads[segmentHeads.length - 1]
    }
    segmentHeads.push(null)
    props.map.remove(lastSegment.segment);
    if (!segmentHeads[segmentHeads.length - 2].next) {
      segmentHeads[segmentHeads.length - 2] = lastSegment.next;
      pointHeads[pointHeads.length - 1].nextSegment = null;
    } else {
      segmentHeads[segmentHeads.length - 2].next = lastSegment.next
      pointHeads[pointHeads.length - 1].next.nextSegment = null;
    }
    if (textHeads[textHeads.length - 1].next) {
      props.map.remove(textHeads[textHeads.length - 1].next.text);
    } else {
      props.map.remove(textHeads[textHeads.length - 1].text);
    }
  }
  props.map.add(selectedArea);
  AMap.plugin("AMap.Geocoder", () => {
    geocoder = new AMap.Geocoder();
  })

  // 加载已有标记
  let tempMarkers = (await request.get('/marker/markers/')).data;
  for (let tempMarker of tempMarkers) {
    await addMarker(tempMarker.mid, [tempMarker.lng, tempMarker.lat], tempMarker.remark, {
      lid: tempMarker.lid,
      did: tempMarker.did,
      sid: tempMarker.sid,
      aid: tempMarker.aid,
      lname: tempMarker.lname,
      dname: tempMarker.dname,
      sname: tempMarker.sname,
      aname: tempMarker.aname
    }, false);
  }
  AMap.plugin("AMap.AutoComplete", () => {
    new AMap.AutoComplete({
      input: searchInput.value
    })
  })
  AMap.plugin("AMap.DistrictSearch", () => {
    district = new AMap.DistrictSearch({
      level: "district", extensions: "all", subdistrict: 0
    });
  });

  // ==================== 地图事件 ====================
  props.map.on('mousemove', (e) => {
    if (!segmentHeads.length) return
    if (!segmentHeads[segmentHeads.length - 1]) return;
    let last = segmentHeads[segmentHeads.length - 1].next
    if (!last) last = segmentHeads[segmentHeads.length - 1]
    if (!last.segment) return
    const start = last.segment.getPath()[0]
    last.segment.setPath([
      start,
      e.lnglat
    ])
    if (textHeads[textHeads.length - 1].next)
      computeDis(start, e.lnglat, textHeads[textHeads.length - 1].next.text)
    else
      computeDis(start, e.lnglat, textHeads[textHeads.length - 1].text)
  })

  props.map.on('click', async (e) => {
    closeDropdown()
    if (isMarkOn) {
      let lnglat = e.lnglat;
      await addMarker(null, lnglat)
      markOff();
    } else if (isSelectOn) {
      let lnglat = e.lnglat;

      await geocoder.getAddress(lnglat, async (status, result) => {
        if (status === 'complete' && result.regeocode) {
          let paths = []

          let counties = (await request.get("/county", {
            params: {
              adcode: result.regeocode.addressComponent.adcode
            }
          })).data
          let address = result.regeocode.addressComponent;
          if (counties.length === 0) {
            await getPolygon(result.regeocode.addressComponent.adcode, paths);
            const geoJson = {
              type: "FeatureCollection",
              features: [
                {
                  type: "Feature",
                  properties: {adcode: result.regeocode.addressComponent.adcode},
                  geometry: {
                    type: "Polygon",
                    coordinates: [paths]
                  }
                }
              ]
            };
            await request.post("/county", {
              cname: address.district,
              adcode: result.regeocode.addressComponent.adcode,
              polygon: btoa(String.fromCharCode.apply(null, new Uint8Array(pako.gzip(JSON.stringify(geoJson))))),
            })
          } else {
            paths = JSON.parse(counties[0].polygon).features[0].geometry.coordinates[0];
          }

          selectedAdcodes.length = 0
          selectedAdcodes.push(result.regeocode.addressComponent.adcode)
          getPolygonFromDatabase(paths, 1)
          selectedArea.setAdcode(result.regeocode.addressComponent.adcode)
          props.map.setFitView(polygons);

          // ===== 打开Vue区县信息窗 =====
          countyDialect.clearSelection();
          countyInfoData.value = {
            address: address.province + address.city + address.district,
            adcode: result.regeocode.addressComponent.adcode,
            countyDialects: (await request.get("/accent/accent/" + result.regeocode.addressComponent.adcode)).data,
          };
          countyInfoLngLat.value = lnglat;
          countyInfoVisible.value = true;
          updateCountyInfoPosition();
        }
      });

    } else if (isRulerOn) {
      if (!isDrawingSegment) {
        isDrawingSegment = true;
        let circleMarker = new AMap.CircleMarker({
          center: e.lnglat,
          radius: 7,
          strokeColor: 'red',
          strokeWeight: 3,
          strokeOpacity: 0.5,
          fillColor: 'red',
          zIndex: 10,
          bubble: false,
          cursor: 'pointer',
          clickable: true,
          draggable: true
        })
        let polyline = new AMap.Polyline({
          path: [e.lnglat, e.lnglat],
          strokeWeight: 2,
          strokeColor: "red",
          lineJoin: "round",
        });
        let text = new AMap.Text({
          text: '',
          style: {
            'background-color': 'white',
            'border-color': '#000',
            'font-size': '12px'
          }
        });

        let segment = {
          segment: polyline,
          text: text,
          next: null,
        }
        let point = {
          point: circleMarker,
          next: null,
          lastSegment: null,
          nextSegment: segment
        }

        if (!segmentHeads.length) {
          segmentHeads.push(segment)
        } else {
          segmentHeads[segmentHeads.length - 1] = segment;
        }
        props.map.add(segment.segment);
        props.map.add(point.point);

        pointHeads.push(point)
        let textNode = {
          text: text,
          next: null
        }

        textHeads.push(textNode)
        props.map.add(textNode.text)
        point.point.on('click', () => {
          deleteTail()
          let p = point;
          while (p !== null) {
            let t = p;
            p = p.next;
            props.map.remove(t.point);
            t = null;
          }
          p = segment;
          while (p !== null) {
            let t = p;
            p = p.next;
            props.map.remove(t.segment);
            t = null;
          }
          p = textNode;
          while (p !== null) {
            let t = p;
            p = p.next;
            props.map.remove(t.text);
            t = null;
          }
        })
        addOnDragging(point)
      } else {
        if (textHeads[textHeads.length - 1].next) {
          props.map.remove(textHeads[textHeads.length - 1].next.text)
        } else {
          props.map.remove(textHeads[textHeads.length - 1].text)
        }
        let circleMarker = new AMap.CircleMarker({
          center: e.lnglat,
          radius: 7,
          strokeColor: 'red',
          strokeWeight: 3,
          strokeOpacity: 0.5,
          fillColor: 'yellow',
          zIndex: 10,
          bubble: true,
          cursor: 'pointer',
          clickable: true,
          draggable: true
        })
        let polyline = new AMap.Polyline({
          path: [e.lnglat, e.lnglat],
          strokeWeight: 2,
          strokeColor: "red",
          lineJoin: "round",
        });
        let text = new AMap.Text({
          text: '',
          style: {
            'background-color': 'white',
            'border-color': '#000',
            'font-size': '12px'
          }
        });

        let segment = {
          segment: polyline,
          text: text,
          next: segmentHeads[segmentHeads.length - 1].next
        }
        let point = {
          point: circleMarker,
          next: pointHeads[pointHeads.length - 1].next,
          lastSegment: null,
          nextSegment: segment,
        }
        textHeads[textHeads.length - 1].next = {
          text: text,
          next: textHeads[textHeads.length - 1].next
        }
        props.map.add(text)
        props.map.add(segment.segment);
        props.map.add(point.point);
        pointHeads[pointHeads.length - 1].next = point;
        const currentHead = segmentHeads[segmentHeads.length - 1]
        if (currentHead.next) {
          const lastSegment = currentHead.next;
          point.lastSegment = lastSegment;
          const start = lastSegment.segment.getPath()[0]
          computeDis(start, e.lnglat, point.lastSegment.text)
          props.map.add(point.lastSegment.text)
          segmentHeads[segmentHeads.length - 1].next = segment
          lastSegment.segment.setPath([start, e.lnglat])
        } else {
          const lastSegment = currentHead;
          point.lastSegment = lastSegment;
          const start = lastSegment.segment.getPath()[0]
          computeDis(start, e.lnglat, point.lastSegment.text)
          props.map.add(point.lastSegment.text)
          segmentHeads[segmentHeads.length - 1].next = segment
          lastSegment.segment.setPath([start, e.lnglat])
        }
        addOnDragging(point)
      }
    }
  })
  props.map.on('rightclick', () => {
    deleteTail()
  });
})

onUnmounted(() => {
  // 清理地图事件
  props.map.off('moveend', updateAllInfoPositions);
  props.map.off('zoomend', updateAllInfoPositions);
})

function addOnDragging(point) {
  point.point.on('dragging', () => {
    if (point.lastSegment) {
      const lastSeg = point.lastSegment.segment
      const start = lastSeg.getPath()[0];
      lastSeg.setPath([start, point.point.getCenter()])
      computeDis(start, point.point.getCenter(), point.lastSegment.text)
    }
    if (point.nextSegment) {
      const nextSeg = point.nextSegment.segment
      const end = nextSeg.getPath()[1];
      nextSeg.setPath([point.point.getCenter(), end])
      computeDis(point.point.getCenter(), end, point.nextSegment.text)
    }
  })
}
</script>

<style scoped>
label {
  margin-left: 20px;
}
.dropdown {
  margin-right: 10px;
}
button {
  color: white;
}
#title {
  display: inline-block;
  width: 150px;
}
#title span {
  font-size: 20px;
  font-weight: bold
}
#menu {
  margin-right: 50px;
  display: flex;
  gap: 20px;
}
.item {
  margin-left: 20px;
  font-size: 20px;
  width: auto;
  height: 60px;
  text-align: center;
  line-height: 60px;
  display: flex;
  gap: 10px;
}
.item:hover {
  background-color: #eeeeee;
  color: hsla(160, 100%, 37%, 1);
  cursor: pointer;
}
#user {
  height: 60px;
  text-align: center;
  line-height: 60px;
  display: inline-block;
  align-content: center;
}
#user:hover {
  background-color: #eeeeee;
  color: hsla(160, 100%, 37%, 1);
  cursor: pointer;
}
#user-profile {
  position: absolute;
  width: 200px;
  height: auto;
  background-color: white;
  border-radius: 5px;
  box-shadow: 3px 6px 6px rgba(0, 0, 0, .15);
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  transform: translateX(-50px);
}
#navbar {
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 60px;
  background-color: white;
  z-index: 100;
}
#right-column {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: auto;
  margin-right: 40px;
}
#dialectSelector {
  padding-top: 5px;
  padding-left: 10px;
  padding-bottom: 15px;
  z-index: 10;
  background-color: white;
  position: absolute;
  text-align: left;
  width: 250px;
  border-radius: 10px;
  box-shadow: 3px 6px 6px rgba(0, 0, 0, .15);
  transform: translateX(-120px) translateY(-25px);
}

/* ========== Vue信息窗覆盖层样式 ========== */
.info-overlay {
  position: fixed;
  z-index: 200;
  pointer-events: auto;
}

.info-card {
  width: 310px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
}

.info-card-title {
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.close-btn {
  color: #999;
  font-size: 14px;
}

.info-label {
  font-size: 12px;
  font-weight: 500;
  color: #555;
  margin-bottom: 2px;
}

.info-value {
  font-size: 12px;
  color: #333;
}

.info-hint {
  font-weight: normal;
  color: #999;
  font-size: 11px;
}

.info-placeholder {
  color: #bbb;
  font-size: 12px;
  margin: 4px 0;
}

.dialect-input {
  margin-top: 4px;
}

.action-link {
  padding: 0;
  font-size: 12px;
  margin-top: 2px;
}

@media (max-width: 768px) {
  #navbar {
    display: inline-block;
  }
  #title {
    display: inline-block;
    width: auto;
  }
  #title span {
    font-size: 17px;
  }
  #right-column {
    display: inline-block;
    margin-left: 30px;
  }
  #menu {
    display: inline-block;
  }
  .item {
    margin-left: 5px;
    display: inline-block;
    font-size: 15px;
    width: auto;
    height: 60px;
    text-align: center;
    line-height: 60px;
  }
  #uname {
    display: none;
  }
  #user {
    display: inline-block;
    position: absolute;
    right: 20px;
  }
  #user-profile {
    transform: translateX(-150px);
    width: 200px;
  }
  #dialectSelector {
    width: 240px;
  }
}
</style>
